const steps = [
  {
    num: '01',
    icon: 'ri-phone-line',
    title: 'Prise de contact',
    description: 'Appelez-nous ou remplissez le formulaire. Nous vous répondons sous 24h pour fixer un rendez-vous.',
  },
  {
    num: '02',
    icon: 'ri-search-eye-line',
    title: 'Visite & diagnostic',
    description: 'Un expert se déplace chez vous pour évaluer les travaux, prendre les mesures et comprendre vos besoins.',
  },
  {
    num: '03',
    icon: 'ri-file-list-3-line',
    title: 'Devis détaillé',
    description: 'Vous recevez un devis clair et transparent, sans surprise. Nous discutons ensemble des options et du budget.',
  },
  {
    num: '04',
    icon: 'ri-hammer-line',
    title: 'Réalisation',
    description: 'Nos artisans qualifiés réalisent les travaux dans les délais convenus, avec un suivi régulier du chantier.',
  },
  {
    num: '05',
    icon: 'ri-check-double-line',
    title: 'Réception & garantie',
    description: 'Visite de réception avec vous, remise des clés et garantie sur tous les travaux réalisés.',
  },
];

export default function RenovationProcess() {
  return (
    <section className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-black text-white mb-4">
            Notre processus<br />
            <span className="text-emerald-400">en 5 étapes</span>
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto text-base">
            Un accompagnement complet de la première prise de contact jusqu'à la livraison de votre chantier.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col items-center text-center">
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[60%] w-full h-px bg-gradient-to-r from-emerald-500/50 to-transparent z-0"></div>
              )}
              <div className="relative z-10 w-16 h-16 flex items-center justify-center bg-emerald-500/20 border-2 border-emerald-500/40 rounded-2xl mb-4">
                <i className={`${step.icon} text-emerald-400 text-2xl`}></i>
                <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center bg-emerald-500 rounded-full text-white text-xs font-black">{step.num}</span>
              </div>
              <h3 className="text-white font-bold text-sm mb-2">{step.title}</h3>
              <p className="text-gray-400 text-xs leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
